//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PADSS',
  data () {
    return {
      form: {
        bp: '',
        active: '',
        nauseaAndVomiting: '',
        pain: '',
        bleeding: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '2', name: '血压波动＜基础值的20%'},
        {value: '1', name: '血压波动＜基础值的20%-40%'},
        {value: '0', name: '血压波动＞基础值的40%'}
      ],
      dataList2: [
        {value: '2', name: '步态稳定、无眩晕感或与术前状态一致'},
        {value: '1', name: '需要帮助行走'},
        {value: '0', name: '无法行走'}
      ],
      dataList3: [
        {value: '2', name: '轻度，无需治疗'},
        {value: '1', name: '中度，可药物治疗'},
        {value: '0', name: '重度，治疗无效'}
      ],
      dataList4: [
        {value: '2', name: 'VAS疼痛评分0~3分'},
        {value: '1', name: 'VAS疼痛评分4~6分'},
        {value: '0', name: 'VAS疼痛评分7~10分'}
      ],
      dataList5: [
        {value: '2', name: '轻度，无需处理'},
        {value: '1', name: '中度，敷料更换2次后无继续出血'},
        {value: '0', name: '重度，敷料更换3次后仍出血'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/PADSS.vue